import {c, color, theme, is_mobile} from './modules/settings.js';

(function ($) {/*
    $(document).on('click', '.js-accordeon-trigger', function(){
      var $title = $(this).parent().find('.ns-accordeon__title');
      var $content = $(this).parent().find('.ns-accordeon__content');

      $title.toggleClass('active');

      if($title.hasClass('active')){
        $content.animate({
            height: $content.get(0).scrollHeight
        }, 200, function(){
            $(this).height('auto');
        });
      }
      else{
        $content.animate({
            height: 0
        }, 200, function(){
            $(this).height('0');
        });
      }

    });*/
})(jQuery);